// Libraries
import React from 'react'
import { ModuleNames } from '../../../../constants/componentNames.constants'
import { SiteURLs } from '../../../../constants/sitemap.constants'
import Layout from '../../../layouts/layout'

// Customer Story Page Modules
import Grid from '@material-ui/core/Grid'
import GlobalContainer from '../../../global/globalContainer'
import KeyStats from '../../../global/keyStats'
import MainCTA from '../../../global/mainCta'
import RelatedCustomerStories from '../../../global/relatedCustomerStories'
import SEOTags from '../../../global/seoTags'
import Typography from '../../../global/typography'
import CustomerStoryHero from '../customerStoryHero'

// Helpers
import ImgUtil from '../../../../utils/img.utils'
import { findTarget, getMicrocopyWithoutNumber } from '../../../../utils/microcopy.utils'
import { renderRichText } from '../../../../utils/richTextHandler.utils'

// Constants
import { LocaleCodes } from '../../../../constants/localization.constants'
import { MicrocopyTitles } from '../../../../constants/microcopy.constants'

// Styles
import WrapperImage from '../../../global/wrapperImage'
import {
  CustomerStoryBackgroundContainer,
  CustomerStoryBodyContent,
  CustomerStoryBodyOuter,
  SideBarItem,
} from './style'

const CustomerStoryPage = ({
  pageContext,
  location,
  path,
  headerData,
  footerData,
  announcementData,
  mainNavBannerData,
  browserLanguageData,
}: any) => {
  let hero: any
  let spotlight: any
  let ctaSection: any
  let pageData = pageContext.resourceData ? pageContext.resourceData : ''
  let relatedStories = pageContext.relatedCustomerStories ? pageContext.relatedCustomerStories : ''
  let generics: { key: string; value: any }[] = []
  generics = pageData?.microcopy?.values || []
  if (pageData && pageData.h1Title) {
    let heroProps = {
      h1Title: pageData.h1Title ? pageData.h1Title : '',
      image: {
        imageSrc:
          pageData.mainImage &&
          pageData.mainImage.image &&
          pageData.mainImage.image.file &&
          pageData.mainImage.image.file.url
            ? pageData.mainImage.image.file.url
            : '/',
        alt: pageData.mainImage && pageData.mainImage.altText ? pageData.mainImage.altText : '',
      },
      pageTitle: pageData.pageName ? pageData.pageName : '',
      microcopy: pageData.customerStoryMicrocopy ? pageData.customerStoryMicrocopy : '',
      slug: pageData.slug ? pageData.slug : '/',
      metaInformation: pageData.metaInformation ? pageData.metaInformation : '',
      breadcrumb: pageData.breadcrumb ? pageData.breadcrumb : '',
    }

    hero = <CustomerStoryHero {...heroProps} />
  }

  if (pageData && pageData.spotlightStats) {
    spotlight = <KeyStats isCustomerStory={true} data={pageData.spotlightStats}></KeyStats>
  }

  if (pageData && pageData.bottomCta) {
    ctaSection = <MainCTA data={pageData.bottomCta}></MainCTA>
  }

  const defaultSlug = pageData && pageData.slug ? pageData.slug : '/'
  const seoData = pageData && pageData.seoMetadata ? pageData.seoMetadata : null

  let defaultLocale
  if (pageContext && pageContext.pageLocale) {
    defaultLocale = pageContext.pageLocale
  } else {
    defaultLocale = LocaleCodes.ENGLISH.code
  }

  const renderPageBody = () => {
    let sideBar: any = []
    let body, microcopy
    if (pageData && pageData.body) {
      body = <CustomerStoryBodyContent>{renderRichText(pageData.body)}</CustomerStoryBodyContent>
    }
    if (pageData && pageData.metaInformation) {
      if (pageData && pageData.customerStoryMicrocopy) {
        microcopy = pageData.customerStoryMicrocopy
      }
      pageData.metaInformation.map((topic: any, i: number) => {
        let microcopyType,
          microcopyElement = ''
        let elementBody
        let eyebrowText
        const topicType = topic.__typename

        if (topicType === ModuleNames.TOPIC_CUSTOMER_DETAILS) {
          microcopyType = MicrocopyTitles.CLIENT
          microcopyElement = MicrocopyTitles.OVERVIEW_TEXT
          if (topic.overview) {
            elementBody = (
              <Typography type="bodyXS" className="SideBar__Item-Body">
                {renderRichText(topic.overview)}
              </Typography>
            )
          }
        }
        if (topicType === ModuleNames.TOPIC_PARTNER_DETAILS) {
          microcopyType = MicrocopyTitles.PARTNER
          microcopyElement = MicrocopyTitles.LOGO_TEXT
          if (
            topic.colorLogo &&
            topic.colorLogo.image &&
            topic.colorLogo.image.file &&
            topic.colorLogo.image.file.url
          ) {
            let altText = topic.colorLogo.altText ? topic.colorLogo.altText : 'UiPath partner logo'
            elementBody = (
              <div className="SideBar__Item-Logo">
                <WrapperImage
                  src={ImgUtil.getResizedImageUrl(topic.colorLogo.image.file.url, `width=450`)}
                  className="SideBar__Item-Logo-File"
                  alt={altText}
                  width={280}
                  height={140}
                  threshold={650}
                />
              </div>
            )
          }
        }

        if (microcopyType && microcopy) {
          eyebrowText = getMicrocopyWithoutNumber(microcopy, microcopyType, microcopyElement)
        }
        if (eyebrowText && eyebrowText[0] && eyebrowText[0].value) {
          sideBar.push(
            <SideBarItem key={`SideBarItem--${i}`}>
              {eyebrowText && eyebrowText[0] && eyebrowText[0].value && (
                <Typography type="captionAlt" className="SideBar__Item-Title">
                  {eyebrowText[0].value}
                </Typography>
              )}
              {elementBody}
            </SideBarItem>
          )
        }
      })
    }
    return (
      <CustomerStoryBodyOuter>
        <Grid
          container={true}
          spacing={3}
          justify="space-between"
          direction="row"
          className="CustomerStory__Body-Container">
          <Grid item={true} md={3} xs={12} className="CustomerStory__SideBar-Grid-Item">
            {sideBar && <div className="SideBar">{sideBar}</div>}
          </Grid>
          <Grid item={true} md={6} xs={12} className="CustomerStory__Body-Grid-Item">
            {body}
            {/* temporaily disable tags on customer stroy page */}
            {/* <TagsContainer>{renderTopics()}</TagsContainer> */}
          </Grid>
        </Grid>
      </CustomerStoryBodyOuter>
    )
  }

  const formattedStoryTopics =
    pageData && pageData.topics && pageData.topics.length && pageData.topics.length > 0
      ? pageData.topics.map((topic: any) => {
          topic.url = topic.title
            ? `${SiteURLs.CUSTOMER_STORIES}/${topic.title
                .toLowerCase()
                .replace(/ *\([^)]*\) */g, '')
                .replace(/\s/g, '-')}`
            : 'https://www.uipath.com/resources/all'

          return topic
        })
      : []

  const renderTopics = () => {
    return (
      <div className="Tags__Group">
        <Typography type="label" className="Tags__Heading">
          {findTarget(`resource.4.TopicsLABEL.text`, generics) || 'Topics:'}
        </Typography>
        {formattedStoryTopics &&
          formattedStoryTopics.map((tag: any) => (
            <a
              key={tag.title}
              className="Tag CustomerStory__Tag"
              href="https://www.uipath.com/resources/all">
              {tag.title}
            </a>
          ))}
      </div>
    )
  }
  const pageInner = (
    <div data-cy="CustomerStory">
      <SEOTags
        seoMetadata={seoData}
        path={path}
        slug={defaultSlug}
        locale={defaultLocale}
        siteSection="Customer Story"
        availableLocales={pageContext.availableLocales}
      />
      {hero}
      {spotlight}
      <CustomerStoryBackgroundContainer>
        <GlobalContainer>{renderPageBody()}</GlobalContainer>
      </CustomerStoryBackgroundContainer>
      {relatedStories && <RelatedCustomerStories data={relatedStories} />}
      {ctaSection}
    </div>
  )

  return (
    <Layout.Template
      lang={defaultLocale}
      headerData={headerData}
      footerData={footerData}
      announcementData={announcementData}
      mainNavBannerData={mainNavBannerData}
      browserLanguageData={browserLanguageData}
      pageType="customerStory"
      slug={defaultSlug}
      availableLocales={pageContext.availableLocales}>
      {pageInner}
    </Layout.Template>
  )
}

export default CustomerStoryPage
